<script>
import EmptyState from '../../../../../components/widgets/EmptyState.vue';
import ButtonNext from 'next/button/Button.vue';

export default {
  components: {
    EmptyState,
    ButtonNext,
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <EmptyState
      :title="$t('WGPT_BOTS.NEW_FLOW.FINISH.TITLE')"
      :message="$t('WGPT_BOTS.NEW_FLOW.FINISH.MESSAGE')"
      :button-text="$t('WGPT_BOTS.NEW_FLOW.FINISH.BUTTON_TEXT')"
    >
      <div class="w-full text-center">
        <router-link
          :to="{
            name: 'wgpt_bots_list',
          }"
        >
          <ButtonNext
            :label="$t('WGPT_BOTS.NEW_FLOW.FINISH.BUTTON_TEXT')"
            color="teal"
          />
        </router-link>
      </div>
    </EmptyState>
  </div>
</template>

<style lang="scss" scoped>
.website--code {
  @apply my-4 mx-auto max-w-[70%];
}
</style>
